import React from 'react';
import { OmniIconComponent } from '../../../../shared';
import AnimatedText from './AnimatedText';

/**
 * SmartSuggestionBanner Component
 * 
 * Shows an AI-style banner at the top of create dialog suggesting
 * that smart suggestions are available
 * 
 * @param {function} onViewClick - Callback when VIEW button is clicked
 * @param {object} metadata - Metadata about suggestions (count, etc.)
 * @param {boolean} isAnimating - Whether to animate the text
 */
const SmartSuggestionBanner = ({ onViewClick, metadata, isAnimating = true }) => {
  const isUserSpecific = metadata?.isUserSpecific;
  const placementCount = metadata?.totalPlacements || 'some';
  
  const message = isUserSpecific 
    ? `We found ${placementCount} similar placements that you've created before. Would you like to see suggested values?`
    : `This is your first time creating this type of placement for this campaign. We found ${placementCount} similar placements with suggested values to help you get started.`;
  
  return (
    <div className="smart-suggestion-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <OmniIconComponent 
            className="is-size-2 ai-icon"
            icon-id="omni:object:insights"
          />
        </div>
        <div className="banner-text">
          <AnimatedText 
            text={message}
            speed={30}
            instant={!isAnimating}
            className="banner-message"
          />
        </div>
        <button 
          className="secondary"
          onClick={onViewClick} 
        >
          VIEW
        </button>
      </div>
    </div>
  );
};

export default SmartSuggestionBanner;
